import { AxiosError } from 'axios';

/**
 * `GET /employee-portal/recognitions` answers 404 with `{ code }` when the company's plan does not
 * include the Engagement Recognition module. That is an absence, not a fault, and it is not an
 * empty list either: the portal reads the code to drop its section rather than invite an employee
 * to a feed their company does not have.
 */
const RECOGNITION_MODULE_INACTIVE_CODE = 'RecognitionModuleInactive';

export const isRecognitionModuleInactiveError = (error: unknown): boolean => {
    if (!(error instanceof AxiosError)) {
        return false;
    }

    const responseData = error.response?.data as { code?: string } | undefined;

    return (
        error.response?.status === 404 && responseData?.code === RECOGNITION_MODULE_INACTIVE_CODE
    );
};

/**
 * The module is there but Engagement could not be reached (503). Nothing is lost and nothing is
 * wrong with the account: the section says so briefly and offers to try again.
 */
export const isEngagementUnavailableError = (error: unknown): boolean =>
    error instanceof AxiosError && error.response?.status === 503;
